import http from '@/services/http/index'
import endpoints from '@/services/http/endpoints'

export default {
  get(payload, assigned = false) {
    const endpoint = assigned ? 'otherChildEditionIdsAssigned' : 'otherChildEditionIds'
    return http.get(endpoints.get(endpoint, { ...payload }))
  }
}
